module.exports = __webpack_public_path__ + "static/001-601b6ede2cd9474b379f4676d882d4d7.png";